import React, { useState } from "react";
import Select from "react-select";

const SupplyChemistDropdown = ({ data, setSelectedChemist }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#ccc" : "#ddd",
      boxShadow: state.isFocused ? "0 0 0 2px #f0f0f0" : "none",
      "&:hover": {
        borderColor: "#bbb",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#f0f8ff"
        : state.isFocused
        ? "#e6f7ff"
        : "white",
      color: state.isSelected ? "#000" : "#333",
      "&:active": {
        backgroundColor: "#cce7ff",
      },
    }),
  };
  

  // Transform data for react-select options
  const options = data.map((chemist) => ({
    value: chemist?.id,
    label: chemist?.storeName,
  }));

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
    const record = data.find(
      (item) => item?.storeName?.trim()?.toLowerCase() === selected?.label?.trim()?.toLowerCase()
    );
    setSelectedChemist(record || null);
  };

  return (
    <div className="dropdownUI">
      <label htmlFor="chemist-dropdown" style={{ marginBottom: "8px", display: "block" }}>
        Select Chemist:
      </label>
      <Select
        styles={customStyles}
        id="chemist-dropdown"
        value={selectedOption}
        onChange={handleSelectChange}
        options={options}
        placeholder="-- Select Chemist --"
        className="allProductsTable__searchBox searchable_dropdown__filter"
        isSearchable
      />
    </div>
  );
};

export default SupplyChemistDropdown;
